import { createAsyncThunk } from '@reduxjs/toolkit';

import { CarDocType } from '@/modules/car/model';
import type { VehicleCreateForm } from '@/modules/car/model/car-form';
import { namespace } from '@/modules/car/namespace';
import { getCarForm } from '@/modules/car/store/selectors';
import { carUploadSelectors } from '@/modules/car/store/upload-slice';
import type { RootState } from '@/root-store';
import { ThunkResult } from '@/shared/actions/thunk-result';

import { updateUploadFormValue } from '../actions';

import { createCar } from './createCar';

let lastRequestId: string | undefined;

type Params = {
  docType: CarDocType;
  vehicleFormValues?: VehicleCreateForm;
  onSuccess?: () => void;
};

const prepareUploadCarForm = createAsyncThunk(
  `${namespace}/prepare-upload-car-form`,
  async (
    { docType, onSuccess, vehicleFormValues }: Params,
    { getState, dispatch, requestId },
  ): Promise<ThunkResult> => {
    lastRequestId = requestId;

    const carForm = getCarForm(getState() as RootState);

    if (!carForm.id && vehicleFormValues) {
      const { isSucceed } = await dispatch(createCar({ formValues: vehicleFormValues })).unwrap();

      if (!isSucceed) {
        return { isSucceed: false };
      }
    }

    if (lastRequestId !== requestId) {
      return { isReplaced: true };
    }

    dispatch(updateUploadFormValue({ docType }));

    const values = carUploadSelectors.getValuesForUploadForm(getState() as RootState);

    dispatch(
      updateUploadFormValue({
        expiresAt: values?.expiresAt,
        file: values?.file,
        status: values?.status,
        rejectReason: values?.rejectReason,
      }),
    );

    onSuccess?.();

    return { isSucceed: true };
  },
);

export { prepareUploadCarForm };
